import request from "@/utils/request"
import type { MenuItemDto, MenuQueryDto, SystemConfigDto, TenantItemDto } from "./types"

/**
 * 获取租户列表
 * @returns
 */
export function getTenantList(): Promise<TenantItemDto[]> {
    return request.get("/admin/tenant/list")
}

/**
 * 获取系统列表
 * @returns
 */
export function getBusinessList(): Promise<any> {
    return request({
        url: '/admin/sys/tenant/business/list',
        method: 'get',
    })
}

export function getLastApk(params: {
    tenantId: string
    serviceCode: string,
    fileType: string,
}): Promise<any> {
    return request.get('/admin/app/version/lastApkAny', {
        params,
        headers: {
            'SERVICE-CODE': 'UNIBOOT'
        }
    })
}

export function getSystemConfig(
    configType: string
): Promise<SystemConfigDto[]> {
    return request.get(`/admin/businessConfig/listByType/${configType}`)
}



/**
 * 获取管理员菜单
 * @returns AxiosPromise<TokenResult>
 */
export function getMenuList(
    params?: MenuQueryDto
): Promise<MenuItemDto[]> {
    return request.get("/admin/menu", {
        params
    })
}

// 获取系统配置
export function getConfigBaseByKey(
    configKey: string
): Promise<SystemConfigDto> {
    return request.get(`/admin/businessConfig/getByKey/${configKey}`)
}
